'use strict'

import Address from './address'
const polyvJsSrc = '//player.polyv.net/script/polyvplayer.min.js'

export default {
  ...Address,
  polyvJsSrc
}

export { Address, polyvJsSrc }
